import {useEffect, useState} from 'react'
import {Button} from 'react-bootstrap'
import {KTIcon, KTSVG} from '../../../../_metronic/helpers'
import ReactSelectBox from '../../../utils/components/ReactSelectBox'
import {useFormik} from 'formik'
import {
  initRouteManageFormValeus,
  overwriteOptions,
  RouteManageFormValuesType,
  statusOptions,
} from '../_model'
import {Sender, useRouteManagement} from '../RouteManagementProvider'
import {Route} from '../../SMSBroadCast/core/_model'
import {getRouteList} from '../../SMSBroadCast/SMSBroadCastRequest'
import {useAuth} from '../../auth'
import {ISelectOption} from '../../../utils/core/_model'
import toast from 'react-hot-toast'
import {BASE_URL} from '../../config'
import {useMutation, useQueryClient} from 'react-query'
import axios, {AxiosResponse} from 'axios'
import RouteSelection from '../RouteSelection'
import * as Yup from 'yup'
import {handleAxiosError} from '../../../utils/helperFunction/_helper'

export interface IRouteOptions extends ISelectOption {
  url: string
}

const CREATE_ROUTE_MANAGE_URL = `${BASE_URL}/api/protect/createRouteSenderRoles`

const routeManageFormSchema = Yup.object().shape({
  name: Yup.string().required('Name is required.'),
})

const RouteManageForm = () => {
  const {auth} = useAuth()
  // const {selectRouteSenderRole} = useRouteManagement()
  // const {senderIdsOptions} = useSenderIdsOptions()

  const {
    setShowSenderModal,
    setSenderSelectType,
    sourceSenderIds,
    destinationSenderIds,
    setDestinationSenderIds,
    setSourceSenderIds,
  } = useRouteManagement()
  const queryClient = useQueryClient()

  const [routeOptions, setRouteOptions] = useState<IRouteOptions[]>([])

  const {mutateAsync: create} = useMutation<
    AxiosResponse,
    Error,
    Partial<RouteManageFormValuesType>
  >({
    mutationFn: async (sendData: Partial<RouteManageFormValuesType>) => {
      const response = await axios.post(CREATE_ROUTE_MANAGE_URL, sendData)

      return response
    },
    onSuccess: (res) => {
      if (res.status === 200) {
        queryClient.invalidateQueries(['createRouteSenderRoles'])
        toast.dismiss()
        toast.success(res.data.message)
        resetForm()
        setDestinationSenderIds(null)
        setSourceSenderIds(null)
      }
    },
    onError: (error: Error) => {
      toast.dismiss()
      const message = handleAxiosError(error)
      toast.error(message)
    },
  })

  const formik = useFormik({
    initialValues: initRouteManageFormValeus,
    validationSchema: routeManageFormSchema,
    onSubmit: async (values) => {
      try {
        toast.loading('Processing..')
        console.log(values)
        if (values.type.toLowerCase() === 'route') {
          const {status, name, sourceRoute, destinationRoute, senderId} = values

          const sendValues: Partial<RouteManageFormValuesType> = {
            name,
            type: '1',
            sourceId: sourceRoute?.id,
            source: sourceRoute?.url,
            destinationId: destinationRoute?.id,
            destination: destinationRoute?.url,
            status: status.toLowerCase() === 'active' ? '1' : '0',
            // senderId: senderId,
          }

          await create(sendValues)
        } else {
          const {status, name} = values

          // console.log(sourceSenderIds)
          // console.log(destinationSenderIds)

          const sendValues: Partial<RouteManageFormValuesType> = {
            name,
            type: '0',
            sourceId: sourceSenderIds![0].id,
            source: getValueSender(sourceSenderIds as Sender[])[0],
            destinationId: destinationSenderIds![0].id,
            destination: getValueSender(destinationSenderIds as Sender[])[0],
            status: status.toLowerCase() === 'active' ? '1' : '0',
          }

          await create(sendValues)
        }
      } catch (error) {
        console.log(error)
      }
    },
  })

  const onShowSenderList = (senderType: string) => {
    setShowSenderModal(true)
    setSenderSelectType(senderType)
  }

  const getValueSender = (senders: Sender[]) => {
    return senders.map((sender) => sender.value)
  }

  const resetForm = () => {
    formik.resetForm()
  }

  // useEffect(() => {
  //   resetForm()
  //   if (selectRouteSenderRole) {
  //     // console.log(selectRouteSenderRole)

  //     formik.setValues({
  //       ...formik.values,
  //       name: selectRouteSenderRole.name,
  //       type: selectRouteSenderRole.type === '1' ? 'Route' : 'Sender',
  //       status: selectRouteSenderRole.status === '1' ? 'Active' : 'Inactive',
  //       source: [selectRouteSenderRole.source],
  //       destination: [selectRouteSenderRole.destination],
  //       senderId: [selectRouteSenderRole.sender_id],
  //     })

  //     setSenderSelectType(selectRouteSenderRole.type === '1' ? 'Route' : 'Sender')
  //     // setRouteSenderIds()
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [selectRouteSenderRole])

  useEffect(() => {
    getRouteList(auth?.accessToken)
      .then((res) => {
        const formatted = res.map((item: Route) => {
          return {
            id: item.id,
            value: item.name,
            label: item.name,
            url: item.url,
          }
        })

        setRouteOptions(formatted)
      })
      .catch((err) => {
        console.log(err)
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className='modal fade' tabIndex={-1} id='kt_modal_1'>
      <div className='modal-dialog modal-xl'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>Rules Form</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
            >
              <KTSVG
                path='/media/icons/duotune/arrows/arr061.svg'
                className='svg-icon svg-icon-2x'
              />
            </div>
          </div>

          <form onSubmit={formik.handleSubmit}>
            <div className='modal-body'>
              <div className='fv-row mb-7'>
                <label className='required fw-semibold fs-6 mb-2'>Name</label>

                <input
                  {...formik.getFieldProps('name')}
                  placeholder='Name'
                  type='text'
                  className='form-control form-control custom-input mb-3 mb-lg-0'
                  autoComplete='off'
                />

                {formik.touched.name && formik.errors.name && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{formik.errors.name}</span>
                    </div>
                  </div>
                )}
              </div>

              <div className='fv-row mb-7'>
                <label className='fw-semibold fs-6 mb-2'>Overwrite Options</label>

                <ReactSelectBox
                  formik={formik}
                  fieldValue='type'
                  placeholder='Select value'
                  options={overwriteOptions}
                />
              </div>

              {formik.values.type.toLowerCase() === 'sender' && (
                <>
                  <div className='fv-row mb-4'>
                    <label className='fw-semibold fs-6 mb-2'>Source & Destination Sender</label>

                    <button
                      type='button'
                      className='ms-6 btn btn-info btn-sm'
                      onClick={() => onShowSenderList('source')}
                      data-bs-dismiss='modal'
                      aria-label='Close'
                    >
                      Choose
                    </button>
                  </div>
                  {sourceSenderIds ? (
                    <div className='mb-4'>
                      <div className='text-gray-800 fs-4 d-flex align-items-center gap-2'>
                        Source
                        <KTIcon iconName='arrow-right' className='fs-2hx' />
                        Destination
                      </div>
                      <div className='text-gray-700 fs-4 d-flex align-items-center gap-2'>
                        {sourceSenderIds[0].value}
                        <KTIcon iconName='arrow-right' className='fs-2hx' />
                        {destinationSenderIds ? destinationSenderIds[0].value : 'Not Selected'}
                      </div>
                    </div>
                  ) : null}
                </>
              )}

              {formik.values.type.toLowerCase() === 'route' && (
                <>
                  <RouteSelection routeOptions={routeOptions} formik={formik} />

                  {/* <div className='fv-row mb-7'>
                    <label className='fw-semibold fs-6 mb-2'>Sender ID</label>

                    <OptimizedSelectBox
                      formik={formik}
                      fieldValue='senderId'
                      placeholder='Select sender'
                      options={senderIdsOptions}
                    />
                  </div> */}
                </>
              )}

              {formik.values.type.toLowerCase() && (
                <>
                  {/* <div className='fv-row mb-7'>
                    <label className='fw-semibold fs-6 mb-2'>Condition</label>

                    <input
                      {...formik.getFieldProps('condition')}
                      placeholder='condition'
                      type='text'
                      className='form-control form-control custom-input mb-3 mb-lg-0'
                      autoComplete='off'
                    />
                  </div> */}

                  <div className='fv-row mb-7'>
                    <label className='fw-semibold fs-6 mb-2'>Status</label>

                    <ReactSelectBox
                      formik={formik}
                      fieldValue='status'
                      placeholder='Select value'
                      options={statusOptions}
                    />
                  </div>
                </>
              )}
            </div>

            <div className='modal-footer'>
              <Button variant='light' data-bs-dismiss='modal' aria-label='Close'>
                Cancel
              </Button>
              <Button type='submit' variant='primary' data-bs-dismiss='modal' aria-label='Close'>
                Create
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default RouteManageForm
